{
  "fr": {
    "placeholders": {
      "name": "Nom",
      "description": "Description",
      "amount": "Montant",
      "login": "Nom d'utilisateur ou e-mail",
      "username": "Nom d'utilisateur",
      "twoFactorCode": "Code à deux facteurs",
      "confirmationCode": "Code de confirmation",
      "email": "E-mail",
      "password": "Mot de passe",
      "passwordConfirmation": "Confirmation du mot de passe",
      "homepage": "Page d'accueil",
      "discord": "Serveur Discord",
      "youtube": "Chaîne Youtube",
      "twitch": "Chaîne Twitch",
      "distance": "Distance",
      "guilded": "Serveur Guilded",
      "color": "Couleur",
      "title": "Titre",
      "classification": "Combat, Industriel, Polyvalent...",
      "focus": "Chasseur léger, Minage, Cargo...",
      "minSize": "snub, small, medium...",
      "maxSize": "medium, large, capital...",
      "minCrew": "Équipage min.",
      "minCargo": "SCU",
      "modelId": "Rechercher un vaisseau",
      "scenario": "Xenothreat, Pirate Swarm, Bounty…",
      "briefing": "Briefing détaillé — comms, indicatifs, règles d'engagement…",
      "location": "Stanton, Pyro, ARC-L1…",
      "meetupLocation": "Daymar, Spaceport — Hangar 4…",
      "maxAttendees": "Limite facultative",
      "autoLockMinutesBefore": "60",
      "timezone": "UTC",
      "startsAt": "Choisir la date et l'heure de début",
      "endsAt": "Choisir la date et l'heure de fin (facultatif)",
      "notes": "J'apporte des munitions, je peux faire du soutien, ETA dans 10…",
      "signup-status": "Confirmé ou provisoire ?",
      "features": {
        "username": "Username or User ID",
        "name": "Nom de fonctionnalité"
      },
      "fleetInviteToken": "Invitation de flotte",
      "quicksearch": {
        "models": "Avenger, Carrack, Cutlass...",
        "hangar": "Enterprise, Andromeda..."
      },
      "search": {
        "default": "Search the Verse...",
        "roadmap-progress-tracker": "Rechercher"
      },
      "home": {
        "search": "Rechercher des vaisseaux..."
      },
      "image": {
        "caption": "Légende"
      },
      "model": {
        "length": "Longueur",
        "beam": "Largeur",
        "height": "Hauteur",
        "price": "Prix",
        "pledgePrice": "Prix de Pledge",
        "onSale": "En vente",
        "mass": "Masse",
        "minCrew": "Équipage min.",
        "maxCrew": "Équipage max.",
        "storeUrl": "Store URL",
        "salesPageUrl": "Sales Page URL",
        "rsiId": "RSI ID",
        "scKey": "SC Key",
        "erkulIdentifier": "Erkul Identifier",
        "productionNote": "Note de production",
        "scmSpeed": "SCM Speed",
        "scmSpeedBoosted": "SCM Speed Boosted",
        "maxSpeed": "Vitesse max.",
        "reverseSpeedBoosted": "Reverse Speed Boosted",
        "quantumFuelTankSize": "Taille du réservoir Quantum",
        "hydrogenFuelTankSize": "Taille du réservoir hydrogène",
        "yaw": "Yaw",
        "pitch": "Pitch",
        "roll": "Roll",
        "yawBoosted": "Lacet boosté",
        "pitchBoosted": "Tangage boosté",
        "rollBoosted": "Roulis boosté",
        "fleetchartOffsetLength": "Décalage longueur du diagramme de flotte",
        "fleetchartOffsetBeam": "Décalage largeur du diagramme de flotte",
        "extendedLength": "Longueur étendue",
        "extendedBeam": "Largeur étendue",
        "extendedHeight": "Hauteur étendue",
        "extendedFleetchartOffsetLength": "Décalage longueur étendue du diagramme de flotte",
        "extendedFleetchartOffsetBeam": "Décalage largeur étendue du diagramme de flotte",
        "landedLength": "Longueur posé",
        "landedBeam": "Largeur posé",
        "landedHeight": "Hauteur posé",
        "landedFleetchartOffsetLength": "Décalage de longueur posé",
        "landedFleetchartOffsetBeam": "Décalage de largeur posé",
        "cargo": "Cargaison",
        "baseModel": "Modèle de base"
      },
      "cargoHold": {
        "offsetX": "Décalage X",
        "offsetY": "Décalage Y",
        "offsetZ": "Décalage Z",
        "rotation": "0 or 90"
      },
      "manufacturer": {
        "longName": "Nom complet",
        "code": "Code",
        "scRef": "SC Ref"
      },
      "announcement": {
        "title": "Que s'est-il passé ?",
        "body": "Markdown. Affiché dans la boîte de réception et dans l'e-mail.",
        "discordPart": "Un message",
        "socialPart": "Un message",
        "link": "/fleets/"
      },
      "fundingGoal": {
        "title": "Coûts serveur, Domaine, Discord...",
        "description": "Contexte facultatif affiché publiquement",
        "amount": "100.00",
        "currency": "EUR",
        "effectiveFrom": "2026-01-01",
        "endedAt": "laisser vide si toujours en cours"
      },
      "supporterContribution": {
        "name": "Nom du soutien affiché publiquement",
        "amount": "5.00",
        "currency": "EUR",
        "startedAt": "2026-01-01",
        "endedAt": "2026-12-31",
        "payerEmail": "donor@example.com",
        "claimKey": "FY-7K2M-9QXD",
        "note": "Note interne facultative"
      },
      "component": {
        "componentClass": "Classe de composant",
        "componentType": "Type de composant",
        "componentSubType": "Sous-type de composant",
        "itemType": "Type d'objet",
        "size": "Taille",
        "grade": "Grade",
        "scKey": "SC Key",
        "scRef": "SC Ref"
      },
      "modelPaint": {
        "pledgePrice": "Prix de Pledge",
        "productionStatus": "Statut de production",
        "productionNote": "Note de production"
      },
      "fleet": {
        "fid": "ID de flotte",
        "rsiSid": "RSI SID",
        "ts": "Serveur Teamspeak",
        "description": "Description",
        "discord": {
          "guildId": "ex. 123456789012345678",
          "channelId": "ID du salon vocal pour l'événement",
          "webhookUrl": "https://discord.com/api/webhooks/…",
          "webhookConfigured": "Enregistré — laisser vide pour conserver l'existant"
        },
        "guilded": "Serveur Guilded",
        "homepage": "Page d'accueil",
        "twitch": "Chaîne Twitch",
        "youtube": "Chaîne Youtube"
      },
      "adminUser": {
        "passwordConfirmation": "Confirmation du mot de passe"
      },
      "user": {
        "rsiHandle": "Pseudo RSI",
        "location": "e.g. Berlin, Germany",
        "currentSystem": "e.g. Stanton, Pyro, Nyx"
      },
      "oauthApplication": {
        "name": "Mon application",
        "redirectUri": "https://example.com/callback",
        "scopes": "public"
      },
      "vehicle": {
        "serial": "Serial"
      },
      "itemPrice": {
        "price": "0.00",
        "location": "Emplacement",
        "locationUrl": "URL de l'emplacement"
      },
      "video": {
        "url": "YouTube Video ID"
      },
      "modelModule": {
        "name": "Nom du Module",
        "price": "0.00",
        "pledgePrice": "0.00",
        "productionStatus": "Annoncé, Prêt au Vol, En Concept...",
        "scKey": "SC Key",
        "search": "Rechercher des modules par nom..."
      },
      "modelUpgrade": {
        "name": "Nom d'amélioration",
        "pledgePrice": "0.00",
        "description": "Description"
      },
      "modelModulePackage": {
        "name": "Nom du paquet",
        "pledgePrice": "0.00",
        "description": "Description"
      },
      "dock": {
        "name": "Nom du quai",
        "length": "Longueur en m",
        "beam": "Largeur en m",
        "height": "Hauteur en m"
      },
      "modelPosition": {
        "name": "Nom du poste",
        "position": "0"
      },
      "logistics": {
        "inventoryName": "Main Depot, Cargo Bay...",
        "description": "Optional details about this inventory",
        "location": "e.g. Port Olisar, Area18",
        "itemName": "Titanium, Medical Supplies..."
      },
      "filters": {
        "vehicles": {
          "name": "Enterprise, Andromeda...",
          "priceLt": "Prix <=",
          "priceGt": "Prix >="
        },
        "models": {
          "name": "Gladius, Andromeda...",
          "classification": "Véhicule, Chasseur, Cargo...",
          "manufacturer": "Origin, Robert Space Industries, Aegis...",
          "onSale": "Oui ou Non",
          "productionStatus": "Annoncé, Prêt au vol, En concept..."
        },
        "modelModules": {
          "name": "Bio Dome, Cargo Module..."
        },
        "manufacturers": {
          "name": "Origin, Robert Space Industries, Aegis..."
        },
        "supporterContributions": {
          "name": "Alice, Bob...",
          "startedAtGteq": "2026-01-01",
          "startedAtLteq": "2026-12-31"
        },
        "adminNotifications": {
          "search": "Titre ou contenu..."
        },
        "users": {
          "search": "Nom d'utilisateur ou e-mail",
          "username": "Nom d'utilisateur",
          "rsiHandle": "Pseudo RSI",
          "email": "E-mail"
        },
        "components": {
          "name": "Nom",
          "description": "lecteur quantique, blindage...",
          "manufacturer": "Behring, Ascension Astro, Juno Starwerk..."
        },
        "fleets": {
          "name": "Nom",
          "fid": "FID",
          "members": {
            "username": "Nom d'utilisateur"
          }
        },
        "destroyedFleets": {
          "nameOrFid": "Nom ou FID"
        },
        "commodities": {
          "name": "Agricium, Laranite, Quantainium...",
          "description": "ore, ammunition, material...",
          "uexCode": "UEX Code"
        },
        "equipment": {
          "name": "Name"
        },
        "notifications": {
          "search": "Titre ou contenu..."
        },
        "blueprints": {
          "name": "Greatsword, Testudo, Omnisky...",
          "material": "Fer, Titane, Aphorite...",
          "craftableType": "Composant, Équipement...",
          "source": "Connue, inconnue..."
        }
      },
      "commodity": {
        "commodityType": "Commodity Type",
        "uexId": "UEX ID",
        "uexCode": "UEX Code",
        "scKey": "SC Key",
        "scRef": "SC Ref"
      },
      "equipment": {
        "equipmentType": "Equipment Type",
        "itemType": "Item Type",
        "subType": "Sub Type",
        "weaponClass": "Weapon Class",
        "size": "Size",
        "grade": "Grade",
        "scKey": "SC Key",
        "scRef": "SC Ref"
      },
      "relationships": {
        "user": {
          "handle": "Nom d'utilisateur de la personne"
        },
        "fleet": {
          "handle": "Identifiant de la flotte"
        }
      },
      "reward": "Récompense en aUEC",
      "crewLimit": "Sans limite",
      "deadline": "Sans échéance",
      "itemName": "Ce qu'il faut livrer",
      "itemQuantity": "Combien",
      "itemQuality": "600"
    }
  }
}
